<a3l-ui-form-group plain>
  <input type="text" autofocus a3l-ui-input [placeholder]="'Wpisz' | translate" #input [value]="address" />
</a3l-ui-form-group>
